/* 🤖 this file was generated by svg-to-ts*/
export const icoMenu: {
  name: 'menu';
  data: string;
} = {
  name: 'menu',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 12H15M3 6H21M3 18H21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  `
};
